export default __webpack_public_path__ + "static/media/workcafe.44f50330.JPG";